export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'array',
  title: ' ',
  options: {
    collapsed: true,
    array_controls_top: true,
    disable_collapse: false,
    disable_array_delete_all_rows: true
  },
  items: { $ref: '#/definitions/routeProductRule' },
  definitions: {
    routeProductRule: {
      type: 'object',
      title: 'Route Product Engine Rule',
      additionalProperties: false,
      properties: {
        rule: {
          type: 'string'
        },
        operation: {
          type: 'string',
          enum: ['add', 'delete', 'match']
        },
        products: {
          type: 'array',
          items: {
            type: 'string'
          }
        }
      },
      required: ['rule', 'operation', 'products']
    }
  }
}
